export default "__VITE_ASSET__BIqax3E$__"